import Image from 'next/image';
import React from 'react';

type AboutCelebrityBannerProps = {
  id?: string;
  backgroundColor?: string;
  heading: string;
  quote: string;
  name: string;
  title: string;
  imageUrl: string;
  imageAlt: string;
};

const AboutCelebrityBanner: React.FC<AboutCelebrityBannerProps> = ({
  id = 'about',
  backgroundColor = '#EDEDED',
  heading,
  quote,
  name,
  title,
  imageUrl,
  imageAlt,
}) => {
  return (
    <section
      className="px-10 md:mt-10 h-auto sm:h-[560px] py-[20px] sm:pw-0 relative"
      id={id}
      style={{ backgroundColor }}
    >
      <div className="max-w-[1306px] w-full mx-auto flex items-center justify-between relative z-20 h-full">
        {/* Text Block */}
        <div className="max-w-[770px] w-full flex-1 flex flex-col text-center sm:text-left relative z-30">
          <h1 className="sm:max-w-[500px] max-w-full w-full text-[#0C0C0C] text-[28px] lg:text-[35px] font-semibold mb-6">
            {heading}
          </h1>

          <div className="text-[22px] lg:text-[30px] font-light">
            {quote}
          </div>

          <div className="flex justify-between items-center w-full">
            <div className="text-[22px] lg:text-[30px] font-light">
              <b className="text-[24px] font-medium">{name}</b>
              <br />
              <p className="text-[17px] lg:text-[20px]">{title}</p>
            </div>
            <Image
              src={imageUrl}
              alt={imageAlt}
              width="467"
              height="689"
              loading="lazy"
              className="block sm:hidden w-[250px] h-auto translate-y-[5%]"
            />
          </div>
        </div>
      </div>

      {/* Image Block - Positioned at section's bottom right */}
      <div className="hidden sm:block absolute bottom-0 right-0 z-10">
        <Image
          src={imageUrl}
          alt={imageAlt}
          width="600"
          height="885"
          loading="lazy"
          className="w-[500px] lg:w-[600px] h-auto"
        />
      </div>
    </section>

  );
};

export default AboutCelebrityBanner;
